'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './checkout-confirmation.component';
import dynamic from 'next/dynamic';

const DynamicCheckoutConfirmationComponent: ComponentType<Props> = dynamic(
  () => import('./checkout-confirmation.component')
);

export default DynamicCheckoutConfirmationComponent;

export function calculateCheckoutConfirmationPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 829 },
    { sinceWidth: 454, height: 812 },
    { sinceWidth: 538, height: 774 },
    { sinceWidth: 600, height: 757 },
    { sinceWidth: 768, height: 845 },
    { sinceWidth: 920, height: 865 },
    { sinceWidth: 1024, height: 662 },
    { sinceWidth: 1442, height: 642 }
  ];

  return {
    heightSinceWidth
  };
}
